import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=aa6a5842&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=aa6a5842&prod&lang=scss"
import style1 from "./CustomerService.vue?vue&type=style&index=1&id=aa6a5842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6a5842",
  null
  
)

export default component.exports